var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAssignment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 25.458h-13A2.708 2.708 0 01.792 22.75V3.25A2.708 2.708 0 013.5.542h13A2.709 2.709 0 0119.21 3.25v19.5a2.709 2.709 0 01-2.709 2.708zM3.5 1.625A1.625 1.625 0 001.875 3.25v19.5A1.625 1.625 0 003.5 24.375h13a1.625 1.625 0 001.625-1.625V3.25A1.625 1.625 0 0016.5 1.625h-13z",
    fill: "#090808"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.459 10.292a.543.543 0 01-.385-.157L6.907 7.968a.544.544 0 11.77-.77l1.782 1.788 3.948-3.954a.544.544 0 01.77.77l-4.334 4.333a.543.543 0 01-.384.157zM13.792 18.417a2.167 2.167 0 110-4.333 2.167 2.167 0 010 4.333zm0-3.25a1.083 1.083 0 100 2.165 1.083 1.083 0 000-2.165z",
    fill: "#090808"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.167 16.792H4.584a.542.542 0 010-1.084h7.583a.541.541 0 110 1.084zM10 21.125H4.584a.542.542 0 010-1.083H10a.541.541 0 110 1.083z",
    fill: "#090808"
  })));
}

export default SvgAssignment;